import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=fc9671c4&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=fc9671c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9671c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc9671c4')) {
      api.createRecord('fc9671c4', component.options)
    } else {
      api.reload('fc9671c4', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=fc9671c4&scoped=true&", function () {
      api.rerender('fc9671c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-243RxGj6pTbjm/JS/comp/Voucher.vue"
export default component.exports